import { createContext } from 'react';

// @ts-ignore
export default createContext<ConfigContextTypes>(null);
